<template>
  <div>
    <user-detail-title
      first-bread="发展历程"
      second-bread="发展历程添加"
      first-url="/user/develop"
      title-name="发展历程添加"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="图片">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="年份">
          <el-input v-model="Alist.year" ></el-input>
        </el-form-item>
        <el-form-item label="文件描述">
          <el-input v-model="Alist.description" type="textarea" :row="3"></el-input>
        </el-form-item>
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "DevelopAdd",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        Large:{},
        Small:{},
        Alist: {
          'year':null,
          'address':null,
          'description':null,
        },//表示Add添加的数据
      }
    },
    methods:{
      GetUrlList(file){
        this.Alist.address=file.data;
      },
      handleAdd(){
        if(this.Alist.year || this.Alist.address || this.Alist.description){
          this.$axios.post('/api/develop/add',this.Alist).then(res=>{
            if(res.data.success == true){
              this.Alist= {
                'year':null,
                'address':null,
                'description':null,
              }//表示Add添加的数据,
              this.$message({
                message:'添加成功',
                type:'success'
              })
            }
          })
        } else {
          this.$message.warning('请选择一项进行添加')
        }
      }
    },
  }
</script>

<style scoped>

</style>